import { styled } from 'styled-components';

const PageStyled = styled.div``;

export default PageStyled;
